/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signing_Search_DocsInputs */

const cs_signing_search_docs = /** @type {(inputs: Signing_Search_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat dokumenty`)
};

const en_signing_search_docs = /** @type {(inputs: Signing_Search_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search documents`)
};

/**
* | output |
* | --- |
* | "Search documents" |
*
* @param {Signing_Search_DocsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const signing_search_docs = /** @type {((inputs?: Signing_Search_DocsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signing_Search_DocsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signing_search_docs(inputs)
	return cs_signing_search_docs(inputs)
});